import { SvgIconProps } from './icon-props';

export function ArrowRight({ height = 15, width = 15, fill = 'none', role }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 15 15"
			fill={fill}
			role={role}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.3016 6.96844L0.937499 6.96844L0.937499 7.9776L12.2899 7.9776L9.01229 11.6256L9.01521 13.0249L14.0625 7.46719L9.01521 1.92188L9.01521 3.30438L12.3016 6.96844Z"
				fill="#030303"
			/>
		</svg>
	);
}
